<script>
export default {
  name: 'MenuItem',
  functional: true,
  props: {
    meta: {
      type: Object
    }
  },
  render(h, context) {
    const { icon = '', title = '' } = context.props.meta || {}
    const vnodes = []

    if (icon) {
      vnodes.push(<img class="menu-icon" src={require(`../../../assets/menu/${icon}.png`)} />)
    }

    if (title) {
      if (icon) {
        vnodes.push(<span slot="title">{title}</span>)
      } else {
        vnodes.push(
          <span class="menu-sub-left-10" slot="title">
            {title}
          </span>
        )
      }
    }
    return vnodes
  }
}
</script>
